import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const findTemplatesAssignedToUser = createAsyncThunk(
    "templateList/findTemplatesAssignedToUser",
    async ({ user }: { user: string }, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`${api.baseURL}formsubmitted`, {
                params: {
                    populate: "false",
                    select: "id,form",
                    where: { user: user}
                }
            });
            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
